import { API_PREFIX_STORES_PATH } from "@/constants/prefix-path-api"
import { message } from "@/lib/config/lib/antd-global"
import type {
    StoreLocalizationRequest,
    StoreRequest,
} from "@/types/codegen/data-contracts"
import { HttpClient } from "../../../../app/api/HttpClient"

interface FetchStoresQueryConfig {
    fields?: string[]
    populate?: string | Record<string, any> | null
    publicationState?: "preview" | "live"
    locale?: string
}

export const fetchStores = async (searchTerms: Record<string, any> = {}, queryConfig: FetchStoresQueryConfig = {}) => {
    const params: any = {
        populate: {
            image: true,
            galeryPhotos: true,
            campaigns: true,
            managers: {
                populate: {
                    image: true
                }
            },
            timeRange: true,
            localizations: true
        },
        sort: "createdAt:desc",
        publicationState: "preview",
        filters: {},
        pagination: {
            page: "1",
            pageSize: "10",
        },
        locale: "all",
    }

    if (queryConfig.fields?.length) {
        params.fields = queryConfig.fields
    }

    if (queryConfig.populate !== undefined) {
        if (queryConfig.populate === null) {
            delete params.populate
        } else {
            params.populate = queryConfig.populate
        }
    }

    if (queryConfig.publicationState) {
        params.publicationState = queryConfig.publicationState
    }

    if (queryConfig.locale) {
        params.locale = queryConfig.locale
    }

    Object.keys(searchTerms).forEach(key => {
        const value = searchTerms[key]
        if (value === undefined || value === "") return

        if (key === "page" || key === "pageSize") {
            params.pagination = {
                ...params.pagination,
                [key]: String(value),
            }
            return
        }

        if (key === "sort") {
            params.sort = String(value)
            return
        }

        if (key === "fields") {
            params.fields = Array.isArray(value)
                ? value
                : String(value)
                    .split(",")
                    .map(item => item.trim())
                    .filter(Boolean)
            return
        }

        if (key === "populate") {
            params.populate = value
            return
        }

        if (key === "publicationState") {
            params.publicationState = value === "published" ? "live" : "preview"
            params.filters.publishedAt =
                value === "draft" ? { $null: true } : undefined
            return
        }

        if (key === "locale") {
            params.locale = typeof value === "string" ? value : undefined
            return
        }

        params.filters[key] = { $containsi: value }
    })

    const res = await HttpClient.get(API_PREFIX_STORES_PATH, { params,skipDomainFilter:true })

    return {
        data: res.data,
        meta: res.meta,
    }
}

export const fetchStoreById = async (id: number, locale?: string) => {

    const populateParams = {
        "populate[image]": "true",
        "populate[galeryPhotos]": "true",
        "populate[timeRange]": "true",
        "populate[campaigns]": "true",
        "populate[managers][populate][image]": "true",
        "populate[localizations]": "true"
    };

    const searchParams = new URLSearchParams(populateParams);
    if (locale) searchParams.append("locale", locale);

    const url = `${API_PREFIX_STORES_PATH}/${id}?${searchParams.toString()}`;
    const res = await HttpClient.get(url,{skipDomainFilter:true});

    return res.data;
}

export const createStore = (data: StoreRequest) =>
    HttpClient.post(API_PREFIX_STORES_PATH, data,{skipDomainFilter:true})

export const updateStoreById = (id: number, data: StoreRequest) =>
    HttpClient.put(`${API_PREFIX_STORES_PATH}/${id}`, data,{skipDomainFilter:true})

export const deleteStoreById = (id: number) =>
    HttpClient.delete(`${API_PREFIX_STORES_PATH}/${id}`,{skipDomainFilter:true})


export const createStoreLocalizationById = async (
    id: number,
    data: { data: StoreLocalizationRequest },
) => {
    try {
        const res = await HttpClient.post(
            `${API_PREFIX_STORES_PATH}/${id}/localizations`,
            data,{skipDomainFilter:true}
        )

        return res

    } catch (err) {
        const error = err as { response?: { data?: { error?: { message?: string } } } }
        message.error(
            error.response?.data?.error?.message || "Thất bại tạo bản dịch!",
        )
        throw err
    }
}

export const stores = {
    fetchStores,
    fetchStoreById,
    createStore,
    updateStoreById,
    deleteStoreById,
    createStoreLocalizationById,
}
